<div class="w-full flex justify-center">
  <div class="flex items-center justify-between gap-3">


    <button
      type="button"
      role="switch"
      [attr.aria-checked]="currentValue"
      [attr.aria-disabled]="isDisabled"
      [attr.aria-label]="label || 'Toggle switch'"
      [disabled]="isDisabled"
      (click)="toggle()"
      (blur)="markAsTouched()"
      (keydown)="onKeydown($event)"
      class="relative inline-flex items-center rounded-full border transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2"
			[ngClass]="[
				sizeClasses.track,
				trackColorClass,
				isInvalid ? 'ring-2 ring-red200' : '',
				validRingClass,
				isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
				!isInvalid ? 'focus:ring-blue200' : 'focus:ring-red200'
			]"
      >
      <span class="sr-only">{{ label || 'Toggle switch' }}</span>
      <span
        class="toggle-thumb inline-block rounded-full bg-white shadow-md transition-transform duration-300 ease-out"
				[ngClass]="[
					sizeClasses.thumb,
					currentValue ? sizeClasses.translate : 'translate-x-0.5'
				]"
      ></span>
    </button>
    @if (label) {
      <label class="text-sm font-bold" [ngClass]="labelClassMap">
        {{ label }}
        @if (required) {
          <span class="ml-1 text-red600">*</span>
        }
      </label>
    }
  </div>

  <div class="mt-1.5 min-h-5 text-xs">
    @if (isInvalid) {
      <p class="text-red600">{{ firstErrorMessage }}</p>
    }
  </div>
</div>
